<template>
  <NoteWithIcon color="yellow">
    <template #icon><IconEmbedded name="info-simple_4" /></template>
    <template #text>
      <div>
        <h3 class="global-h5">Long Distance Creator Visit</h3>
        <div>
          This creator visit is outside your current travel boundary.
          <br />
          Reminder that the same compensation and visit requirements apply whether it's 50 or 500 miles away!
        </div>
      </div>
    </template>
  </NoteWithIcon>
</template>

<script setup lang="ts">
import NoteWithIcon from "@components/NoteWithIcon.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
</script>
